/// <reference path="../../app.d.ts"/>

import { AppUtils } from '../../../../../shared/utils/index';
import { User } from '../../../../../shared/models/api/User/User';
import { BasicUserService } from '../../../../../shared/services/BasicUserService';
import { AppPersistenceService } from '../services/AppPersistenceService';
import { UploadPersistenceService } from '../../../../../shared/services/UploadPersistenceService';
import { BasicApplicationService } from '../../../../../shared/services/BasicApplicationService';
import { AppApiService } from '../services/AppApiService';
import { defaults } from '../defaults';

import { DamageOhcPageController } from './steps/DamageOhcPageController';
import { DocumentsBillsOhcPageController } from './steps/DocumentsBillsOhcPageController';
import { PersonalDataOhcPageController } from './steps/PersonalDataOhcPageController';
import { CheckOhcPageController } from './steps/CheckOhcPageController';
import { ConfirmationOhcPageController } from './steps/ConfirmationOhcPageController';

export class App implements AppController {
	private stepController: StepController;
	private readonly appPersistanceService: AppPersistenceService;
	private readonly uploadPersistenceService: UploadPersistenceService;
	private readonly appApplicationService: BasicApplicationService<DamageDeclarationOhcAppDefinition>;
	private readonly userService: BasicUserService;
	private readonly $ctx: JQuery;
	private readonly options: DamageDeclarationOhcOptions;
	private readonly loader: BasicLoader<DamageDeclarationOhcAppDefinition>;
	private appApiService: AppApiService;


	constructor(element: HTMLElement, options: DamageDeclarationOhcOptions, loader: BasicLoader<DamageDeclarationOhcAppDefinition>) {
		this.loader = loader;
		this.options = $.extend(true, {}, defaults, options);
		this.$ctx = this.options.$ctx;

		this.userService = new BasicUserService();
		this.appPersistanceService = new AppPersistenceService(this.options);
		this.uploadPersistenceService = new UploadPersistenceService(this.options);
		this.appApplicationService = new BasicApplicationService(this.options);
	}

	public start(): void {
		// check precondition if cookie/session already exists than show clusterbox/layer
		this.callDependencyLoader();
	}

	public callDependencyLoader(): void {
		this.loader._loadDependencies(this.initApplication.bind(this));
	}

	public initApplication(): void {
		AppUtils.View.startLoader("damagedeclarationohc initApplication");
		this.appPersistanceService.prepareApplicationSession();
		if (!this.appPersistanceService.getDamageOhcFormModel()) {
			this.uploadPersistenceService.clearApplicationSession();
		}
		this.userService.getUser((user: User) => {
			this.appApiService = new AppApiService(this.options, user);
			this.setVorgangsnummer();
			if (this.appApplicationService.isStep(1)) {
				this.stepController = new DocumentsBillsOhcPageController(this, this.options, this.loader, user);
				this.stepController.start();
			} else if (this.appApplicationService.isStep(2)) {
				this.stepController = new PersonalDataOhcPageController(this, this.options, this.loader, user);
				this.stepController.start();
			} else if (this.appApplicationService.isStep(3)) {
				this.stepController = new CheckOhcPageController(this, this.options, this.loader, user);
				this.stepController.start();
			} else if (this.appApplicationService.isStep(4)) {
				this.stepController = new ConfirmationOhcPageController(this, this.options, this.loader, user);
				this.stepController.start();
			} else {
				this.stepController = new DamageOhcPageController(this, this.options, this.loader, user);
				this.stepController.start();
			}
		});
	}

	public afterRenderApp(): void {
		this.loader.initAdditionalModules(this.$ctx);
		S.Utils.Lightbox.init();
		this.loader.complete();
	}

	private setVorgangsnummer(): void {
		const applicationModel = this.appPersistanceService.getApplicationModel();
		if (applicationModel.Vorgangsnummer === undefined) {
			this.appApiService.getVorgangsnummer('SchadenmeldungAKS',
				(data: ApiResponse<string>) => {
					applicationModel.Vorgangsnummer = data.Data;
					this.appPersistanceService.setApplicationModel(applicationModel);
				}, () => {
					T.Utils.Helper.routeToUrl(this.options.app.errorpageurl);
				});
		}
	}
}
